import { configPublic } from '@src/config.public'
import { CardNetwork, CardType } from '@src/utils/constants.util'

export const locales = {
  'en-US': {
    name: 'English',
    code: 'en-US',
    codeSnakeCase: 'en_US',
    path: '/us/en',
    storeKey: 'bodi-us',
    countryCode: 'US',
    countryCodeLowercase: 'us',
    countryIsoCode: 'USA',
    lang: 'en',
    langUppercase: 'EN',
    currency: 'USD',
    subrateLabels: {},
    addressDataset: 'us-address',
    switcherLabel: 'U.S. English',
    flag: '/images/us_flag.svg',
    payerAuthRequired: false,
    payerAuthAdministrativeAreaHasCountry: false,
    merchantIdKey: 'bodi-us',
    cardTypes: new Array<CardType>(
      CardType.Visa,
      CardType.Mastercard,
      CardType.AMEX,
      CardType.Discover
    ),
    allowedCardNetworks: new Array<CardNetwork>(
      CardNetwork.VISA,
      CardNetwork.MASTERCARD,
      CardNetwork.AMEX,
      CardNetwork.DISCOVER,
      CardNetwork.CUP
    ),
    emptyCartRedirectUrl: '/c/fitness',
    savedAddressesEnabled: true,
    savedPaymentsEnabled: true,
    shopifyLanguagePathSegment: '/en',
    allowedPathPatterns: [],
    fallbackLocale: 'en-US',
    fallbackPath: '/',
    faq: {
      homepageSupported: true,
      topAnswersSupported: false,
      answersIndexSupported: false,
      smsSupported: true,
      emailSupported: false,
    },
  },
  'en-CA': {
    name: 'English (Canada)',
    code: 'en-CA',
    codeSnakeCase: 'en_CA',
    path: '/ca/en',
    storeKey: 'bodi-ca',
    countryCode: 'CA',
    countryCodeLowercase: 'ca',
    countryIsoCode: 'CAN',
    lang: 'en',
    langUppercase: 'EN',
    currency: 'CAD',
    subrateLabels: { GST: 'GST', PST: 'PST', HST: 'HST', QST: 'QST', RST: 'RST' },
    addressDataset: 'ca-address',
    switcherLabel: 'CAN English',
    flag: '/images/ca_flag.svg',
    payerAuthRequired: false,
    payerAuthAdministrativeAreaHasCountry: false,
    merchantIdKey: 'bodi-ca',
    cardTypes: new Array<CardType>(
      CardType.Visa,
      CardType.Mastercard,
      CardType.AMEX,
      CardType.Discover
    ),
    allowedCardNetworks: new Array<CardNetwork>(
      CardNetwork.VISA,
      CardNetwork.MASTERCARD,
      CardNetwork.AMEX,
      CardNetwork.DISCOVER,
      CardNetwork.CUP
    ),
    emptyCartRedirectUrl: '/c/fitness',
    savedAddressesEnabled: true,
    savedPaymentsEnabled: true,
    shopifyLanguagePathSegment: '/en',
    allowedPathPatterns: [],
    fallbackLocale: 'en-CA',
    fallbackPath: '/',
    faq: {
      homepageSupported: true,
      topAnswersSupported: false,
      answersIndexSupported: false,
      smsSupported: true,
      emailSupported: false,
    },
  },
  'fr-CA': {
    name: 'Français (Canada)',
    code: 'fr-CA',
    codeSnakeCase: 'fr_CA',
    path: '/ca/fr',
    storeKey: 'bodi-ca',
    countryCode: 'CA',
    countryCodeLowercase: 'ca',
    countryIsoCode: 'CAN',
    lang: 'fr',
    langUppercase: 'FR',
    currency: 'CAD',
    subrateLabels: { GST: 'TPS', PST: 'TVQ', HST: 'TVH', QST: 'TVQ', RST: 'TVH' },
    addressDataset: 'ca-address',
    switcherLabel: 'CAN Français',
    flag: '/images/ca_flag.svg',
    payerAuthRequired: false,
    payerAuthAdministrativeAreaHasCountry: false,
    merchantIdKey: 'bodi-ca',
    cardTypes: new Array<CardType>(
      CardType.Visa,
      CardType.Mastercard,
      CardType.AMEX,
      CardType.Discover
    ),
    allowedCardNetworks: new Array<CardNetwork>(
      CardNetwork.VISA,
      CardNetwork.MASTERCARD,
      CardNetwork.AMEX,
      CardNetwork.DISCOVER,
      CardNetwork.CUP
    ),
    emptyCartRedirectUrl: '/c/fitness',
    savedAddressesEnabled: true,
    savedPaymentsEnabled: true,
    shopifyLanguagePathSegment: '/fr',
    allowedPathPatterns: [],
    fallbackLocale: 'en-CA',
    fallbackPath: '/',
    faq: {
      homepageSupported: true,
      topAnswersSupported: false,
      answersIndexSupported: false,
      smsSupported: true,
      emailSupported: false,
    },
  },
  'en-GB': {
    name: 'English (United Kingdom)',
    code: 'en-GB',
    codeSnakeCase: 'en_GB',
    path: '/gb/en',
    storeKey: 'bodi-gb',
    countryCode: 'GB',
    countryCodeLowercase: 'gb',
    countryIsoCode: 'GBR',
    lang: 'en',
    langUppercase: 'EN',
    currency: 'GBP',
    subrateLabels: {},
    addressDataset: 'gb-address',
    switcherLabel: 'UK English',
    flag: '/images/gb_flag.svg',
    payerAuthRequired: true,
    payerAuthAdministrativeAreaHasCountry: true,
    merchantIdKey: 'bodi-gb',
    cardTypes: new Array<CardType>(CardType.Visa, CardType.Mastercard),
    allowedCardNetworks: new Array<CardNetwork>(CardNetwork.VISA, CardNetwork.MASTERCARD),
    emptyCartRedirectUrl: '/',
    savedAddressesEnabled: false,
    savedPaymentsEnabled: false,
    shopifyLanguagePathSegment: '/en',
    allowedPathPatterns: [],
    fallbackLocale: 'en-GB',
    fallbackPath: '/',
    faq: {
      homepageSupported: true,
      topAnswersSupported: false,
      answersIndexSupported: false,
      smsSupported: false,
      emailSupported: true,
    },
  },
  'en-AU': {
    name: 'English (Australia)',
    code: 'en-AU',
    codeSnakeCase: 'en_AU',
    path: '/au/en',
    storeKey: 'bodi-us',
    countryCode: 'AU',
    countryCodeLowercase: 'au',
    countryIsoCode: 'AUS',
    lang: 'en',
    langUppercase: 'EN',
    currency: 'AUD',
    subrateLabels: {},
    addressDataset: 'us-address',
    switcherLabel: 'AUS English',
    flag: '/images/au_flag.svg',
    payerAuthRequired: false,
    payerAuthAdministrativeAreaHasCountry: false,
    merchantIdKey: 'bodi-us',
    cardTypes: new Array<CardType>(CardType.Visa, CardType.Mastercard),
    allowedCardNetworks: new Array<CardNetwork>(CardNetwork.VISA, CardNetwork.MASTERCARD),
    emptyCartRedirectUrl: '/',
    savedAddressesEnabled: false,
    savedPaymentsEnabled: false,
    shopifyLanguagePathSegment: '/en',
    allowedPathPatterns: ['/faq', '/faq/**'],
    fallbackLocale: 'en-US',
    fallbackPath: '/faq',
    faq: {
      homepageSupported: false,
      topAnswersSupported: true,
      answersIndexSupported: true,
      smsSupported: false,
      emailSupported: true,
    },
  },
  'fr-FR': {
    name: 'Français (France)',
    code: 'fr-FR',
    codeSnakeCase: 'fr_FR',
    path: '/fr/fr',
    storeKey: 'bodi-us',
    countryCode: 'FR',
    countryCodeLowercase: 'fr',
    countryIsoCode: 'FRA',
    lang: 'fr',
    langUppercase: 'FR',
    currency: 'EUR',
    subrateLabels: {},
    addressDataset: 'us-address',
    switcherLabel: 'FR Français',
    flag: '/images/fr_flag.svg',
    payerAuthRequired: false,
    payerAuthAdministrativeAreaHasCountry: false,
    merchantIdKey: 'bodi-us',
    cardTypes: new Array<CardType>(CardType.Visa, CardType.Mastercard),
    allowedCardNetworks: new Array<CardNetwork>(CardNetwork.VISA, CardNetwork.MASTERCARD),
    emptyCartRedirectUrl: '/',
    savedAddressesEnabled: false,
    savedPaymentsEnabled: false,
    shopifyLanguagePathSegment: '/fr',
    allowedPathPatterns: ['/faq', '/faq/**'],
    fallbackLocale: 'en-US',
    fallbackPath: '/faq',
    faq: {
      homepageSupported: true,
      topAnswersSupported: false,
      answersIndexSupported: false,
      smsSupported: false,
      emailSupported: true,
    },
  },
} as const

for (const localeCode in locales) {
  const isSupported = configPublic.general.supportedLocales.includes(localeCode)
  if (!isSupported) delete locales[localeCode as LocaleCode]
}

export const i18nConfig = {
  defaultLocale: 'en-US',
  defaultLocaleByCountry: {
    US: 'en-US',
    CA: 'en-CA',
    GB: 'en-GB',
    AU: 'en-AU',
    FR: 'fr-FR',
  },
  defaultNamespace: 'common',
  locales,
}

export type LocaleCode = keyof typeof locales
export type LocaleConfig = (typeof locales)[LocaleCode]
export type LocaleCodeSnakeCase = LocaleConfig['codeSnakeCase']
export type LocalePath = LocaleConfig['path']
export type StoreKey = LocaleConfig['storeKey']
export type Currency = LocaleConfig['currency']
export type CountryCode = LocaleConfig['countryCode']
export type CountryCodeLowercase = LocaleConfig['countryCodeLowercase']
export type CountryIsoCode = LocaleConfig['countryIsoCode']
export type Lang = LocaleConfig['lang']
export type LangUppercase = LocaleConfig['langUppercase']
export type AddressDataset = LocaleConfig['addressDataset']
export type LocaleCardTypes = LocaleConfig['cardTypes']
export type I18nConfig = typeof i18nConfig

// TBB backwards compatibility
export type LocaleCodeTBB = LocaleCode | 'es-US'
export type CountryCodeTBB = Exclude<CountryCode, 'AU'>
export type LangTBB = Lang | 'es'
